import type { IObjective } from "@bbj-types/challenge";
import { Stack, Typography } from "@mui/material";
import { useI18nContext } from "@root/utils/organisation";
import type { TPaperCandidateChallengeObjective } from "../types";

export interface IPaperCandidateObjectiveTitleProps<T extends TPaperCandidateChallengeObjective> {
  objective: Pick<IObjective, "name" | "active">;
  candidateObjective: T;
}

export const PaperCandidateObjectiveTitle = <T extends TPaperCandidateChallengeObjective>({
  objective,
  candidateObjective,
}: IPaperCandidateObjectiveTitleProps<T>) => {
  const { timeZone } = useI18nContext();
  const inactiveText = !objective.active ? " (Type d'objectif obsolète)" : "";

  return (
    <Stack>
      <Typography variant="subtitle1SemiBold">
        {candidateObjective.label || objective.name}
        {candidateObjective.deadline &&
          ` - ${candidateObjective.deadline.toLocaleString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            timeZone,
          })}`}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
        }}
      >
        {typeof candidateObjective.createdFromCer === "boolean" &&
          (candidateObjective.createdFromCer ? "Objectif du CE" : "Hors CE")}
        {typeof candidateObjective.createdFromCer === "boolean" &&
          (Boolean(candidateObjective.label) || !objective.active) &&
          " - "}
        {Boolean(candidateObjective.label) && objective.name}
        {inactiveText}
      </Typography>
    </Stack>
  );
};
